import { createContext, useContext } from 'react';

interface FormNavigationContextValue {
    closeModal?: () => void;
}

export const FormNavigationContext = createContext<FormNavigationContextValue>({});

export const useFormNavigationContext = () => useContext(FormNavigationContext);
